import * as React from "react";
import "./MethodText.scss";
import PropTypes from "prop-types";

const MethodText = (props) => {
  const text = props.text;
  const textClass = `method-desktop-text`;
  const limitWidthClass = props.limitWidth
    ? ` method-desktop-text-${props.limitWidth}`
    : "";
  const alignmentClass = ` method-desktop-text-${props.alignment}`;
  const borderClass = props.hasBorder ? ` method-desktop-bordered` : "";
  return (
    <section className={textClass + borderClass}>
      <div className={"method-desktop-text-adaptive " + alignmentClass}>
        <div className={limitWidthClass}>{text && text}</div>
      </div>
    </section>
  );
};

MethodText.propTypes = {
  text: PropTypes.string.isRequired,
  limitWidth: PropTypes.string,
  hasBorder: PropTypes.boolean,
  alignment: PropTypes.string.isRequired,
};

export default MethodText;
